import { z } from 'zod';

/**
 * `POST /api/agent/turns/:conversationId/steer`: a message into the running turn. With
 * `request`, it answers the agent's question tool (that tool call id): refused
 * (`accepted: false`) once the question no longer waits, else it is marked answered.
 */
export const steerTurnRequestSchema = z.object({
  turnId: z.uuid(),
  text: z.string().trim().min(1).max(100_000),
  messageId: z.string().trim().min(1).max(200),
  request: z.string().trim().min(1).max(256).optional(),
});

export type SteerTurnRequest = z.infer<typeof steerTurnRequestSchema>;

/** Its answer: whether the running turn took the message. */
export type SteerTurnResponse = { accepted: boolean };
